
import { URLS } from '../constants'
import {
    GET_ALL_CREDIT_POLICIES_BEGIN, GET_ALL_CREDIT_POLICIES_SUCCESS, GET_ALL_CREDIT_POLICIES_FAILURE,
    GET_CREDIT_POLICY_BEGIN, GET_CREDIT_POLICY_SUCCESS, GET_CREDIT_POLICY_FAILURE,
    POST_CREDIT_POLICY_BEGIN, POST_CREDIT_POLICY_SUCCESS, POST_CREDIT_POLICY_FAILURE,
    PUT_CREDIT_POLICY_BEGIN, PUT_CREDIT_POLICY_SUCCESS, PUT_CREDIT_POLICY_FAILURE,
    ACTIVATE_CREDIT_POLICY_BEGIN, ACTIVATE_CREDIT_POLICY_SUCCESS, ACTIVATE_CREDIT_POLICY_FAILURE,
    DELETE_CREDIT_POLICY_BEGIN, DELETE_CREDIT_POLICY_SUCCESS, DELETE_CREDIT_POLICY_FAILURE
} from '../constants/ActionTypes'

import { dispatchFetchGet, dispatchFetchPost, dispatchFetchPut, dispatchFetchDelete } from './ActionUtil'

// Get All Credit Policies
const acGetAllCreditPoliciesBegin = () => ({ type: GET_ALL_CREDIT_POLICIES_BEGIN })
const acGetAllCreditPoliciesSuccess = data => ({ type: GET_ALL_CREDIT_POLICIES_SUCCESS, payload: data })
const acGetAllCreditPoliciesFailure = err => ({ type: GET_ALL_CREDIT_POLICIES_FAILURE, payload: err })

/**
 * @description Retrieves all credit policies from the server.
 *
 * @author Maria Eduarda Franke
 */
export const acGetAllCreditPolicies = () => {
    return dispatchFetchGet(
        URLS.CREDIT_POLICY,
        acGetAllCreditPoliciesBegin,
        acGetAllCreditPoliciesSuccess,
        acGetAllCreditPoliciesFailure
    )
}

// Get Credit Policy
const acGetCreditPolicyBegin = () => ({ type: GET_CREDIT_POLICY_BEGIN })
const acGetCreditPolicySuccess = data => ({ type: GET_CREDIT_POLICY_SUCCESS, payload: data })
const acGetCreditPolicyFailure = err => ({ type: GET_CREDIT_POLICY_FAILURE, payload: err })

/**
 * @description Dispatches a GET request to retrieve a credit policy.
 *
 * @author Maria Eduarda Franke
 */
export const acGetCreditPolicy = creditPolicyId => {
    return dispatchFetchGet(
        `${URLS.CREDIT_POLICY}/${creditPolicyId}`,
        acGetCreditPolicyBegin,
        acGetCreditPolicySuccess,
        acGetCreditPolicyFailure
    )
}

// Post Credit Policy
const acPostCreditPolicyBegin = () => ({ type: POST_CREDIT_POLICY_BEGIN })
const acPostCreditPolicySuccess = data => ({ type: POST_CREDIT_POLICY_SUCCESS, payload: data })
const acPostCreditPolicyFailure = err => ({ type: POST_CREDIT_POLICY_FAILURE, payload: err })

/**
 * @description Dispatches a POST request to create a credit policy.
 *
 * @author Maria Eduarda Franke
 */
export const acPostCreditPolicy = creditPolicy => {
    return dispatchFetchPost(
        URLS.CREDIT_POLICY,
        { ...creditPolicy },
        acPostCreditPolicyBegin,
        acPostCreditPolicySuccess,
        acPostCreditPolicyFailure
    )
}

// Put Credit Policy
const acPutCreditPolicyBegin = () => ({ type: PUT_CREDIT_POLICY_BEGIN })
const acPutCreditPolicySuccess = data => ({ type: PUT_CREDIT_POLICY_SUCCESS, payload: data })
const acPutCreditPolicyFailure = err => ({ type: PUT_CREDIT_POLICY_FAILURE, payload: err })

/**
 * @description Dispatches a PUT request to update a credit policy.
 *
 * @author Maria Eduarda Franke
 */
export const acPutCreditPolicy = (creditPolicyId, creditPolicy) => {
    return dispatchFetchPut(
        `${URLS.CREDIT_POLICY}/${creditPolicyId}`,
        { ...creditPolicy },
        acPutCreditPolicyBegin,
        acPutCreditPolicySuccess,
        acPutCreditPolicyFailure
    )
}

// Activate/Desactivate Credit Policy
const acActivateCreditPolicyBegin = () => ({ type: ACTIVATE_CREDIT_POLICY_BEGIN })
const acActivateCreditPolicySuccess = data => ({ type: ACTIVATE_CREDIT_POLICY_SUCCESS, payload: data })
const acActivateCreditPolicyFailure = err => ({ type: ACTIVATE_CREDIT_POLICY_FAILURE, payload: err })

/**
 * @description Dispatches a PUT request to activate or desactivate a credit policy.
 *
 * @author Maria Eduarda Franke
 */
export const acActivateCreditPolicy = creditPolicyId => {
    return dispatchFetchPut(
        `${URLS.CREDIT_POLICY}/${creditPolicyId}/activate`,
        {},
        acActivateCreditPolicyBegin,
        acActivateCreditPolicySuccess,
        acActivateCreditPolicyFailure
    )
}

// Delete Credit Policy
const acDeleteCreditPolicyBegin = () => ({ type: DELETE_CREDIT_POLICY_BEGIN })
const acDeleteCreditPolicySuccess = data => ({ type: DELETE_CREDIT_POLICY_SUCCESS, payload: data })
const acDeleteCreditPolicyFailure = err => ({ type: DELETE_CREDIT_POLICY_FAILURE, payload: err })

/**
 * @description Dispatches a DELETE request to delete a credit policy.
 *
 * @author Maria Eduarda Franke
 */
export const acDeleteCreditPolicy = creditPolicyId => {
    return dispatchFetchDelete(
        `${URLS.CREDIT_POLICY}/${creditPolicyId}`,
        acDeleteCreditPolicyBegin,
        acDeleteCreditPolicySuccess,
        acDeleteCreditPolicyFailure
    )
}